'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.defaults = defaults;
exports.forEach = forEach;
exports.removeDocumentMeta = removeDocumentMeta;

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Tools
 */

function clone(_ref) {
  var children = _ref.children;

  var source = _objectWithoutProperties(_ref, ['children']);

  return source ? JSON.parse(JSON.stringify(source)) : {};
}

function defaults(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    if (!target.hasOwnProperty(key)) {
      target[key] = source[key];
    } else if (_typeof(target[key]) === 'object' && !Array.isArray(target[key]) && target[key]) {
      defaults(target[key], source[key]);
    }

    return target;
  }, target);
}

function forEach(arr, fn) {
  Array.prototype.slice.call(arr || []).forEach(fn);
}

/**
 * Validation
 */

// const VALID_PROPS = ['title', 'description', 'canonical', 'meta', 'link'];

// export function isValidProp ( propKey ) {
//   return ~VALID_PROPS.indexOf( propKey );
// }

/**
 * Document manipulation
 */

function removeNode(node) {
  node.parentNode.removeChild(node);
}

function removeDocumentMeta() {
  forEach(document.querySelectorAll('head [data-rdm]'), removeNode);
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-document-meta/dist/utils.js
 ** module id = 847
 ** module chunks = 0
 **/